import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, filter, map, of, switchMap, withLatestFrom } from 'rxjs';
import { DashboardService } from 'src/app/core/dashboard/dashboard.service';
import * as JobsDataActions from './actions';
import { AppStateInterface } from '../types';
import { Store } from '@ngrx/store';
import { successJobFavoritesDataSelector } from './selectors';

@Injectable()
export class JobsDataEffect {
  getJobsData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(JobsDataActions.getJobsData),
      switchMap((action) => {
        return this.dashboardService.getJobs(action.jobsQuery).pipe(
          map((jobsData) => {
            return JobsDataActions.getJobsDataSuccess(jobsData);
          }),
          catchError((error) => of(JobsDataActions.getJobsDataFailure(error))),
        );
      }),
    ),
  );


  getJobFavoritesData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(JobsDataActions.getJobFavoritesData),
      // withLatestFrom(this._store.select(successJobFavoritesDataSelector)),
      // filter(([ action, getJobFavoritesDataSuccess ]) => {
      //   debugger
      //   return !getJobFavoritesDataSuccess}
      // ),
      switchMap(() => {
        return this.dashboardService.getJobFavorites().pipe(
          map((favoriteJobs) => {
            return JobsDataActions.getJobFavoritesDataSuccess(favoriteJobs)
          }),
          catchError((error) => of(JobsDataActions.getJobFavoritesDataFailure({error: error.message})))
        )
      })
    )
  );

  constructor(
    private actions$: Actions,
    private _store: Store<AppStateInterface>,
    private dashboardService: DashboardService,
  ) {}
}
